<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue';
import * as Sentry from '@sentry/vue';
import { ImmersveError } from '@/common/ImmersveError';
import { getMessage } from '@/common/getMessage';
import ErrorScreen from '@/components/ui/ErrorScreen.vue';

const inError = ref(false);

onErrorCaptured((err) => {
  const wrapped =
    err instanceof ImmersveError
      ? err
      : ImmersveError.create({
          name: 'UnhandledAppError',
          message: getMessage(err),
        });
  Sentry.captureException(wrapped);
  inError.value = true;
  return false;
});
</script>

<template>
  <slot v-if="!inError" />
  <ErrorScreen v-else />
</template>
